import React, { forwardRef, memo } from "react";
import { IconButton, IconButtonProps } from "@chakra-ui/react";

const CircularIconButton = forwardRef<any, IconButtonProps>((props, ref) => (
  <IconButton ref={ref} rounded="full" variant="ghost" {...props} />
));

export default memo(CircularIconButton);
